import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, DefaultHttpUrlGenerator, DefaultPluralizer, HttpUrlGenerator, Logger } from '@ngrx/data';
import { MicrosoftEvent } from '@octiga/microsoft-events/src/interfaces/meta.interface';
import { EMPTY, Observable } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';
import { pluralNames } from '../../entity-metadata';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

@Injectable()
export class EventDataService extends DefaultDataService<MicrosoftEvent<any, any>[]> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, logger: Logger) {
        logger.log(http, httpUrlGenerator);
        const url = new DefaultHttpUrlGenerator(new DefaultPluralizer([pluralNames]));
        url.registerHttpResourceUrls({ Label: { entityResourceUrl: 'event', collectionResourceUrl: 'events' } });
        super('Event', http, url);
    }

    private fetchWithPaging<T>(msp: string, tenant: string, ids: string[]): Observable<any[]> {
        const unique_ids = [...new Set(ids)];
        const request_batches: string[][] = []; // batching is limited to 100 items per batch

        let count = 0;
        do {
            const start = count * 100;
            const end = start + 100;
            request_batches.push(unique_ids.slice(start, end));
        } while (++count * 100 < unique_ids.length);

        let current_batches = 0;

        console.log('unique_ids', unique_ids);

        return this.http
            .post(`/api/microsoft/monitoring/events`, unique_ids, {
                headers: {
                    ...headers,
                    'msp-id': msp,
                    'tenant-id': tenant,
                },
            })
            .pipe(
                expand((data: any) => {
                    current_batches++;
                    if (current_batches < request_batches.length) {
                        return this.http.post<T[]>(
                            `/api/microsoft/monitoring/events`,
                            request_batches[current_batches],
                            {
                                headers: {
                                    ...headers,
                                    'msp-id': msp,
                                    'tenant-id': tenant,
                                },
                            },
                        );
                    } else {
                        return EMPTY;
                    }
                }),
                reduce((acc, data: any) => {
                    return acc.concat(data);
                }, []),
            );
    }

    override getWithQuery(params: { msp: string; tenant: string; ids: string[] }) {
        const { msp, tenant, ids } = params;
        return this.fetchWithPaging<MicrosoftEvent<any, any>[]>(msp, tenant, ids);
    }
}
